(() => {
  angular.module('app').component('commonComponentsRecentClaimsTicketsComponent', {
    templateUrl: require('./recentClaimsTickets.component.html'),
    controller: RecentClaimsTicketsController,
    controllerAs: 'vm',
    bindings: {
      isInpatient: '<',
      titleKey: '@',
    },
  });

  RecentClaimsTicketsController.$inject = [
    '$stateParams',
    'abp.services.app.claim',
    'abp.services.app.nprClaim',
    'Hms.Claims.ClaimantRelation',
    'Hms.Claims.ClaimStatus',
    'Hms.Services.ServiceType',
  ];

  function RecentClaimsTicketsController(
    $stateParams,
    claimSvc,
    nprClaimSvc,
    enumClaimantRelation,
    enumClaimStatus,
    enumServiceType
  ) {
    const vm = this;

    const pageSize = 10;

    // IhmAso is a transitionary inpatient service type that predates the shared ServiceType enum
    // and is not a member of it, so its id has to be named here. Its own localisation reads
    // "Hospitalisation".

    const ihmAsoServiceTypeId = 251;

    // Localisation key per service type id, taken from the enum so that a service type cannot be
    // left out and render as an empty cell.

    const serviceTypeLabelKeys = enumServiceType.values.reduce((keys, serviceType) => {
      keys[serviceType.id] = serviceType.name;
      return keys;
    }, {});

    serviceTypeLabelKeys[ihmAsoServiceTypeId] = 'IhmAso';

    // One icon per claim status. A status left out of here would render no icon at all, so every
    // member of the enum is listed.

    const statusIconClasses = {
      [enumClaimStatus.Submitted.id]: 'fa fa-file text-warning',
      [enumClaimStatus.Approved.id]: 'fa fa-check-circle success-text',
      [enumClaimStatus.Paid.id]: 'fa fa-check-circle primary-text',
      [enumClaimStatus.Rejected.id]: 'fa fa-times-circle danger-text',
      [enumClaimStatus.Cancelled.id]: 'fas fa-redo warning-text',
      [enumClaimStatus.MarkedForPayment.id]: 'far fa-money-bill-alt success-text',
      [enumClaimStatus.HrToApprove.id]: 'fas fa-user-clock',
      [enumClaimStatus.PendingInsuranceUtilization.id]: 'fas fa-hourglass-half warning-text',
    };

    vm.loading = 0;
    vm.records = [];
    vm.totalCount = 0;
    vm.rangeStart = 0;
    vm.rangeEnd = 0;

    vm.enums = {
      claimantRelation: enumClaimantRelation,
    };

    vm.permissions = {
      canViewTicket: abp.auth.isGranted('PatientTickets'),
    };

    vm.getStatusIconClass = getStatusIconClass;
    vm.getServiceTypeLabel = getServiceTypeLabel;
    vm.hasPreviousPage = hasPreviousPage;
    vm.hasNextPage = hasNextPage;
    vm.previousPage = previousPage;
    vm.nextPage = nextPage;

    let skipCount = 0;

    init();

    function init() {
      getRecords();
    }

    function getRecords() {
      // The inpatient table lists hospitalisation records and the outpatient table everything else,
      // so the two tables stay separate and each has its own endpoint.

      const claimService = vm.isInpatient ? nprClaimSvc : claimSvc;

      // The range is worked out from the skip count that asked for this page, not from whatever
      // skipCount holds when the response lands, so a page and its range cannot disagree.

      const requestedSkipCount = skipCount;

      vm.loading += 1;
      claimService
        .getRecentClaimsTickets({
          claimNumber: $stateParams.claimNumber,
          skipCount: requestedSkipCount,
          maxResultCount: pageSize,
        })
        .success((data) => {
          vm.records = data.items;
          vm.totalCount = data.totalCount;
          vm.rangeStart = data.totalCount ? requestedSkipCount + 1 : 0;
          vm.rangeEnd = requestedSkipCount + data.items.length;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getStatusIconClass(status) {
      return statusIconClasses[status];
    }

    function getServiceTypeLabel(record) {
      // A custom service type carries its organisation's own name for it on the record.

      if (record.ctName) {
        return record.ctName;
      }

      const labelKey = serviceTypeLabelKeys[record.serviceType];
      return labelKey ? App.localize(labelKey) : '';
    }

    function hasPreviousPage() {
      return skipCount > 0;
    }

    function hasNextPage() {
      return skipCount + vm.records.length < vm.totalCount;
    }

    function previousPage() {
      skipCount = Math.max(0, skipCount - pageSize);
      getRecords();
    }

    function nextPage() {
      skipCount += pageSize;
      getRecords();
    }
  }
})();
